<script setup lang="ts">
import { Subscription } from "rxjs";
import { PropType } from "vue";
import { DBFactory } from "~/classes/database/db_factory";

const props = defineProps({
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => [],
    required: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const tags = ref<string[]>();
const subscription = ref<Subscription>();

onMounted(() => {
  const db = DBFactory.createDatabase();

  subscription.value?.unsubscribe();

  subscription.value = db
    .streamList({
      collection: "evaluationTestTags",
      path: "evaluationTestTags",
    })
    .subscribe((data) => {
      tags.value = data.map((item) => item.id);
    });
});
</script>

<template>
  <BaseSelectInput
    :options="tags"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    mode="tags"
    placeholder="Select tags"
    :can-clear="true"
    :searchable="true"
  />
</template>

<style scoped></style>
